import { AxiosError } from 'axios'
import { toast } from 'sonner'
import { ApiError } from '@/lib/api-client'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)

  let errMsg = 'Ocurrió un error.'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number((error as { status?: unknown }).status) === 204
  ) {
    errMsg = 'Contenido no encontrado.'
  } else if (error instanceof ApiError) {
    // apiFetch already extracts the message from the backend envelope
    // ({ error: { message } } / { message }) or the plain-text body.
    errMsg = error.message || errMsg
  } else if (error instanceof AxiosError) {
    errMsg =
      error.response?.data?.error?.message ??
      error.response?.data?.message ??
      error.response?.data?.title ??
      error.message ??
      errMsg
  } else if (error instanceof Error) {
    errMsg = error.message || errMsg
  }

  toast.error(errMsg)
}
